import React, { Component } from 'react'

import * as utils from "../utils";
import * as actions from "./actions";
import { openSlideshow } from "../slideshow/actions";

import CommentForm from "../posts/components/comment-form";
import FetchingContent from "../common/components/fetching-content";
import FileUploadButton from "../file-uploader/components/file-upload-button";
import RsvpToPerformActionLink from "../common/components/rsvp-to-perform-action-link";

import { connect } from 'react-redux';

const PhotoGallery = React.createClass({
  render: function() {
    const { objects, more, cursor, fetchingPhotos } = this.props.state.photos;
    const hasPhotos = objects.length > 0;
    const canPostPhotos = utils.canPostPhotos();

    if (window.evite_event.options.event_option_disable_feed) {
      return <h3 className="feed-notice">The host has hidden photos</h3>;
    }
    if (fetchingPhotos) {
      return <FetchingContent fetching="photos" />;
    }

    const fileUpload = this.props.state.fileupload;
    const { isUploading, stagedFiles } = fileUpload;

    return (
      <div className="photo-gallery-wrap">
        <div className="photo-gallery simple-shadowbox">
          { !canPostPhotos &&
            <RsvpToPerformActionLink action="post a photo" />
          }
          { canPostPhotos && !hasPhotos &&
            <NoPhotosNotice />
          }
          { canPostPhotos &&
            <div className="header-panel">
              { this.props.state.hasStagedFiles ?
                <CommentForm />
              :

                <FileUploadButton
                  buttonClass="button-primary-inverse"
                  stagedFiles={stagedFiles}
                  maxFiles={fileUpload.maxFiles}
                  isUploading={isUploading}
                  onClick={this.handleClick}
                />
              }
            </div>
          }
          <PhotoGrid objects={objects}/>
          { more &&
            <ShowMorePhotosLink cursor={cursor}/>
          }
        </div>
      </div>
    )
  },

  handleClick: function(event) {
    if (window.evite_event.status === 'cancelled') {
      new ModalWarning({
          title: 'Error',
          body: 'Event is cancelled'
      }).show();
      event.preventDefault();
    }
  }
})

function NoPhotosNotice(props) {
  return (
    <h3 className="feed-notice">
      There are no photos yet - be the first!
    </h3>
  )
}

function PhotoGrid(props) {
  const { objects } = props;
  const photo_nodes = objects.map((photo, i) => {
    return (
      <PhotoPanel
        imgUrl={photo.content.url}
        postId={photo.id}
        key={photo.id}
        size="600"
      />
    );
  });
  return (
    <div className="photo-panels">
      {photo_nodes}
    </div>
  )
}

const PhotoPanel = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const imgUrl = this.props.imgUrl;
    const imgSize = this.props.size || 600;
    const panelStyle = {
      backgroundImage: `url(${imgUrl}=s${imgSize})`
    };

    return (
      <a className="photo-panel" style={panelStyle} onClick={this.onPhotoClick}>
        <div></div>
      </a>
    )
  },
  onPhotoClick: function(e) {
    const postId = this.props.postId;
    e.preventDefault();
    openSlideshow(postId);
  }
});

const ShowMorePhotosLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <a onClick={this.handleShowMoreClick} className="show-more-link">
        Show More Photos
      </a>
    )
  },
  handleShowMoreClick: function(e) {
    e.preventDefault();
    actions.getPhotoPosts(this.props.cursor);
  }
});

function mapStateToProps(state) {
  return {
    state: {
      photos: state.photos,
      fileupload: state.fileupload,
      hasStagedFiles: state.fileupload.stagedFiles.count > 0
    }
  }
}

const connectedPhotoGallery = connect(mapStateToProps)(PhotoGallery);

export default connectedPhotoGallery;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/photos/components.es6